import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { ViewPositionsComponent } from './views/positions/view-positions.component';
import { UserComponent } from './views/user/user.component';
import {RxFormBuilder} from "@rxweb/reactive-form-validators";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'positions',
    component: ViewPositionsComponent,
  },
  {
    path: 'user',
    component: UserComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [RxFormBuilder],
})
export class HomeRoutingModule {}
